module.exports = __webpack_public_path__ + "static/media/searchBtn.18721493.png";